import React from 'react';
import { motion } from 'framer-motion';
import { AtomIcon, BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-blue-900" data-id="element-107" data-mp="sai2qz5n6n4o">
      <div className="metal-silver h-1.5 w-full" aria-hidden="true" data-id="element-108" data-mp="nc87ypntxojl" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-109" data-mp="nbydaoruat7k">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="metal-silver inline-flex items-center gap-2 rounded-full border border-slate-400 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-blue-950" data-id="element-110" data-mp="3d2torapbqmf2">
          <AtomIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="39aurjeh4toxr" /> Nuclear Energy Teacher Ready
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-112" data-mp="3e8mt707kwpf5">
          Master your year of nuclear energy education
          <br data-id="element-113" data-mp="2viojkfo4uo9e" />
          <span className="metal-silver-text" data-id="element-114" data-mp="2vi55ja1lsk0n">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-115" data-mp="2hinc2hdd4iky">
          <img src={productImage} alt="Nuclear Energy Teacher Ready: nine volumes and five bonus resources covering nuclear fundamentals, atomic science, radiation and fission, reactors, the fuel cycle, safety, waste management, nuclear energy in society and teaching" className="mx-auto w-full drop-shadow-[0_24px_44px_rgba(0,0,0,.35)]" data-id="element-116" data-mp="s3cloaja7jqk" />
        </motion.div>

        <div className="mt-9" data-id="element-117" data-mp="1ayt7t2zvvpch">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-118" data-mp="1622jxthu7pgi">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-white" data-id="element-119" data-mp="110wnployxk28">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-300/30 bg-blue-950/60 px-3 py-2" data-id="element-120" data-mp="3ltgndrclksov">
              <Icon className="h-3.5 w-3.5 text-slate-300" aria-hidden="true" data-id="element-121" data-mp="1x9b590wn91ck" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-slate-300" data-id="element-122" data-mp="21bxx31tbem9r">
          Created by nuclear energy education specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}